






























































import { Component } from 'vue-property-decorator';

import MarkdownToHTML from '@/common/MarkdownToHTML';
import BaseView from '@/views/BaseView.vue';
import QuestionResources from '@/models/entry/QuestionResources';

import ModelAnswer from '@/models/entry/ModelAnswer';
import ExamAudio from '@/components/ExamAudio.vue';
import * as StringUtil from '@/common/StringUtil';

import RepositoryFactory from '@/repository/RepositoryFactory';
import axios from 'axios';

/**
 * リソースダウンロード情報まとめ
 */
 interface DownloadInfo {
  uri: string;
  modelAnswer: ModelAnswer;
  resource: QuestionResources;
}

@Component({
  components: {
    'e-audio': ExamAudio,
  },
})
export default class ExamResultModelAnswer extends BaseView {
  private entryCode = '';

  private resultCode = '';

  private activeQuestionNumber = -1;

  private modelAnswers: ModelAnswer[] = [];

  private viewModelAnsers: { index: number; evaluationCode: string; evaluationTitle: string; modelAnswers: ModelAnswer[]}[] = [];

  private totalDownloadDataCount = 0;

  private nowLoadingCount = 0;

  private async mounted() {
    const { entry, result } = this.$route.query;
    if (entry === undefined || result === undefined) {
      this.$router.replace(this.paths.TOP);
    }
    this.entryCode = String(entry);
    this.resultCode = String(result);

    await this.getModelAnswers()
      .then(() => {
        this.resourceDownload();
      })
      .then(() => {
        this.formatModelAnswers();
      });
  }

  /** データを評価基準ごとのまとまりに整形する */
  private async formatModelAnswers() {
    this.viewModelAnsers.length = 0;
    this.modelAnswers.forEach((ma) => {
      const modelAnswer = ma;
      const { evaluationCode } = ma;
      const idx = this.viewModelAnsers.findIndex((v) => v.evaluationCode === evaluationCode);
      if (idx === -1) {
        const index = this.viewModelAnsers.length;
        const vma = {
          index, evaluationCode, evaluationTitle: modelAnswer.evaluationTitle, modelAnswers: [modelAnswer],
        };
        this.viewModelAnsers.push(vma);
        return;
      }
      this.viewModelAnsers[idx].modelAnswers.push(modelAnswer);
    });
  }

  private async getModelAnswers() {
    const EntryRepository = RepositoryFactory.get().entry;
    await EntryRepository.getModelAnswers(this.entryCode, this.resultCode).then((response: any) => {
      if (response.status !== 200) {
        return;
      }
      this.modelAnswers = EntryRepository.convert.deserializeArray(response.data.details, ModelAnswer);
      if (this.modelAnswers.length < 1) {
        return;
      }
      this.modelAnswers.forEach((ma, index) => {
        const modelAnswer = ma;
        // 出題順番号付与
        modelAnswer.questionNumber = index + 1;

        // 模範回答のMarkdownパース
        if (modelAnswer.modelAnswer !== null) {
          modelAnswer.modelAnswer = MarkdownToHTML(modelAnswer.modelAnswer);
        }
        // 問題文のMarkdownパース
        if (modelAnswer.question !== null) {
          modelAnswer.question.questionStatement = MarkdownToHTML(modelAnswer.question.questionStatement);
        }
        modelAnswer.subQuestions.forEach((subQuestion) => {
          const subQ = subQuestion;
          // 設問タイトルのMarkdownパース
          if (subQ.subQuestionTitle !== '') {
            subQ.subQuestionTitle = MarkdownToHTML(subQ.subQuestionTitle);
          }
          // 取得された設問情報を解答情報にセット
          subQ.answer.questionCode = subQ.questionCode;
          subQ.answer.version = subQ.version;
          subQ.answer.order = subQ.order;
          subQ.choices.forEach((choice) => {
            // 設問選択肢のMarkdownパース
            const c = choice;
            c.choiceTitle = MarkdownToHTML(c.choiceTitle);
          });
        });
        modelAnswer.answerChoices.forEach((answerChoice) => {
          const c = answerChoice;
          c.choiceTitle = MarkdownToHTML(answerChoice.choiceTitle);
        });
        modelAnswer.correctChoices.forEach((correctChoice) => {
          const c = correctChoice;
          c.choiceTitle = MarkdownToHTML(correctChoice.choiceTitle);
        });
      });
    });
  }

  private async resourceDownload() {
    if (this.modelAnswers.length < 1) {
      return;
    }

    this.modelAnswers.forEach((ma) => {
      const modelAnswer = ma;
      if (modelAnswer.question === null) {
        return;
      }

      modelAnswer.question.questionResources.forEach((resourceData) => {
        this.totalDownloadDataCount += 1;
        const resource = resourceData;
        const uri = `${process.env.VUE_APP_DESIGN_RESOURCE_BASE}${resource.resourceUri}`;
        const downloadInfo: DownloadInfo = { uri, modelAnswer, resource };
        // ダウンロード実行
        this.execDownload(downloadInfo);
      });
    });
  }

  /**
   * リソースダウンロード処理
   */
  private async execDownload(downloadInfo: DownloadInfo) {
    const { uri, modelAnswer, resource } = downloadInfo;
    // arraybuffer オプション必須
    axios.get(uri, { responseType: 'arraybuffer' })
      .then((response) => {
        const contentType = response.headers['content-type'].split(';')[0];
        const blob = new Blob([response.data], { type: contentType });
        const srcUrl = URL.createObjectURL(blob);
        // ダウンロードされたファイルの実体を保持
        resource.contents = blob;
        resource.contentType = contentType;
        resource.localSrcUri = srcUrl;

        this.nowLoadingCount += 1;

        if (contentType.indexOf('image') === -1) {
          return;
        }
        // 画像の場合、各所の対応する独自タグを置換
        const replaceTag = `{{${resource.resourceFileName}}}`;
        const imgTagString = `<img src="${srcUrl}" alt="${resource.alternativeText}" />`;
        if (modelAnswer.question === null) {
          return;
        }
        // 問題本文
        modelAnswer.question.questionStatement = modelAnswer.question.questionStatement.replace(replaceTag, imgTagString);

        // 問題解説
        if (!StringUtil.isEmpty(modelAnswer.modelAnswer)) {
          modelAnswer.modelAnswer = modelAnswer.modelAnswer.replace(replaceTag, imgTagString);
        }

        const { subQuestions } = modelAnswer.question;
        subQuestions.forEach((subQ) => {
          const targetSubq = subQ;
          // 設問タイトル
          targetSubq.subQuestionTitle = targetSubq.subQuestionTitle.replace(replaceTag, imgTagString);
          targetSubq.choices.forEach((choice) => {
            const targetChoice = choice;
            // 問題選択肢
            targetChoice.choiceTitle = targetChoice.choiceTitle.replace(replaceTag, imgTagString);
          });
        });
        modelAnswer.answerChoices.forEach((choice) => {
          const targetChoice = choice;
          targetChoice.choiceTitle = targetChoice.choiceTitle.replace(replaceTag, imgTagString);
        });
        modelAnswer.correctChoices.forEach((choice) => {
          const targetChoice = choice;
          targetChoice.choiceTitle = targetChoice.choiceTitle.replace(replaceTag, imgTagString);
        });
      });
  }

  /**
   * content-type に該当するリソースURIとコンテンツタイプを返す
   */
  static getResourceInfo(type: string, questionResources: QuestionResources[]) {
    const resource = questionResources.find((value) => {
      if (!StringUtil.isEmpty(value.contentType)) {
        const contentsType = value.contentType;
        if (contentsType.indexOf(type) !== -1) return true;
      }
      return false;
    });

    if (resource) {
      const { localSrcUri, contentType } = resource;
      return { localSrcUri, contentType };
    }
    return null;
  }

  /**
   * 動画リソース情報取得
   */
  // eslint-disable-next-line class-methods-use-this
  getVideoInfo(questionResources: QuestionResources[]) {
    return ExamResultModelAnswer.getResourceInfo('video', questionResources);
  }

  /**
   * 音声リソース情報取得
   */
  // eslint-disable-next-line class-methods-use-this
  getAudioInfo(questionResources: QuestionResources[]) {
    return ExamResultModelAnswer.getResourceInfo('audio', questionResources);
  }

  modalClose() {
    this.activeQuestionNumber = -1;
  }
}
